import { useDropzone } from "react-dropzone";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { IconCloudUpload, IconTrash, IconX } from "@tabler/icons-react";
import { useState } from "react";

const DropComponent = ({ onDrop, files, setFiles }: any) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: { "image/*": [] },
    multiple: true,
    onDrop,
  });

  const removeImage = (indexToRemove: number) => {
    setFiles((prevFiles: any) =>
      prevFiles.filter((_: any, index: any) => index !== indexToRemove)
    );
  };

  const [previewImg, setPreviewImg] = useState<string | null>(null);

  return (
    <>
      <Paper
        {...getRootProps()}
        sx={{
          p: 2,
          textAlign: "center",
          border: "2px dashed #1976d2",
          borderRadius: 2,
          backgroundColor: isDragActive ? "#e3f2fd" : "transparent",
          cursor: "pointer",
        }}
      >
        <input {...getInputProps()} />
        <IconCloudUpload size={48} stroke={1.5} />
        <Typography mt={2}>Fotos do seu produto</Typography>
        <Typography variant="body2" color="text.secondary" mt={1}>
          Clique ou arraste o arquivo para esta área para fazer upload
        </Typography>
      </Paper>

      {files.length > 0 && (
        <Stack mt={2}>
          {files?.map((item: any, index: any) => {
            const src =
              item instanceof File ? URL.createObjectURL(item) : item?.img;
            return (
              <Stack
                key={index}
                sx={{
                  justifyContent: "space-between",
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                }}
              >
                <Stack
                  alignItems="center"
                  flexDirection="row"
                  gap={"1rem"}
                  onClick={() => setPreviewImg(src)}
                >
                  <img
                    src={src}
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "10px",
                      cursor: "pointer",
                    }}
                  />
                  <Typography color="error">
                    {item?.name || item?.img}
                  </Typography>
                </Stack>
                <IconButton color="error" onClick={() => removeImage(index)}>
                  <IconTrash />
                </IconButton>
              </Stack>
            );
          })}
        </Stack>
      )}

      <Dialog
        open={!!previewImg}
        onClose={() => setPreviewImg(null)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Visualização
          <IconButton
            aria-label="close"
            onClick={() => setPreviewImg(null)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <IconX />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <img
            src={previewImg || ""}
            alt="Preview"
            style={{
              maxWidth: "100%",
              maxHeight: "80vh",
              width: "200px",
              height: "200px",
              display: "block",
              margin: "0 auto",
              borderRadius: "10px",
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DropComponent;
